import { IFeature } from "@/apps/credit-line/models/CreditLineDetails";

/**
 * Checks if a specific experiment has a truthy "bucket" value.
 *
 * This function searches for an experiment by name within either an array or an object
 * of experiments and returns a boolean indicating whether the experiment exists and has
 * a truthy value in its `bucket` property.
 *
 * This will be removed once the new structure is safely rolled out
 *
 * @param {string} featureName - The name of the experiment to search for.
 * @param {IFeature[] | Record<string, IFeature>} features - The list or object of experiments to search within.
 * @returns {boolean} - Returns `true` if the experiment has a truthy "bucket" value, otherwise `false`.
 */
export const isFeatureEnabled = (
  featureName: string,
  features: IFeature[] | Record<string, IFeature>
): boolean => {
  if (!features) return false;

  if (Array.isArray(features)) {
    // Legacy support: Search through array of experiments
    return Boolean(features.find((item) => item.name === featureName)?.bucket);
  } else {
    // New structure: Search through object of experiments
    return Boolean(features[featureName]?.bucket);
  }
};
